import styled from 'styled-components';

import { sectionHead } from '../../styles/mixins';

const Container = styled.div`
  ${sectionHead}
`;

const TitleGroup = styled.div`
  min-width: 0;
`;

const SeeAll = styled.button`
  height: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex: none;
  white-space: nowrap;
  background: transparent;
  border: none;
  padding: 0;
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--accent-deep);

  :hover {
    text-decoration: underline;
  }
`;

export { Container, SeeAll, TitleGroup };
